<template>
  <div class="container">
    <header>
      <h1 id="logo">Taskflow </h1>
      <router-link class="routerlink" to="/worker">Start</router-link>
    </header>
    <div class="content">
      <h1 class="greeting">Hallo, melde dich an um weiterzumachen</h1>
      <p>Wenn du noch keine zuganscode hast, frage im Buero nach.</p>
      <router-link class="link" to="/worker">Gehe zur Web App</router-link>
    </div>
    <div class="footer">
      <div class="auth-container">
        <router-link class="auth-button" to="/manage/mitarbeiter">Büro</router-link>
        <router-link class="auth-button" to="/worker">Montage</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderView from '@/components/HeaderView.vue';
import axios from 'axios';
import { keycloak } from '../keycloak';
export default {
  name: 'Welcome',
  components: {
    HeaderView
  },
  data() {
    return {
      name: ''
    };
  },


  mounted() {
  axios.interceptors.request.use(config => {
    config.headers['Authorization'] = `Bearer ${keycloak.token}`; // Beispiel-Header
    return config;
  }, error => {
    return Promise.reject(error);
  });
  
  const fetchrole = async () => {
    try {
      const response = await axios.get(`/api/role`);
      this.$router.push(`/${response.data.role}`); 
      console.log(`/${response.data.role}`)

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  this.name = localStorage.getItem('name') || 'Gast';
  fetchrole();
}

}
</script>

<style scoped>
#logo{
  color: #059669;
}
.routerlink{
color: white;
text-decoration: none;
font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
padding: 10px 15px;
}
.routerlink:hover{
color: white;
text-decoration: none;
font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
padding: 10px 15px;
background-color: #059669;
border-radius: 10px;
}
header{
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 60px;
}
/* Basis-Stile für die Seite */
.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #111827; /* Dunkler Hintergrund */
  color: #D1D5DB; /* Heller Text */
  font-family: 'Inter', sans-serif;
}

/* Header-Stile */
HeaderView {
  /* Falls HeaderView spezifische Stile benötigt, hier hinzufügen */
}

/* Hauptbereich-Stile */
.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
}

/* Begrüßungsnachricht-Stile */
.greeting {
  font-family: 'Inter', sans-serif; /* Konsistente Schriftart */
  font-size: 2rem;
  color: #F3F4F6; /* Heller Text */
  margin: 0;
  padding: 0;
}

/* Link-Stile */
.link {
  margin-top: 20px;
  text-decoration: none;
  color: #3B82F6; /* Blau für einen modernen Look */
  font-size: 1rem;
  padding: 10px 20px;
  border-radius: 8px;
  background-color: #1F2937; /* Dunklerer Hintergrund */
  border: 1px solid #3B82F6;
  transition: background-color 0.3s ease, color 0.3s ease, transform 0.3s ease;
}

.link:hover {
  background-color: #374151; /* Hellere Hover-Farbe */
  color: #F3F4F6; /* Weißer Text beim Hover */
  transform: scale(1.05);
}

/* Footer-Stile */
.footer {
  display: flex;
  justify-content: center;
  padding: 20px;
  background: #1F2937; /* Dunklerer Hintergrund für den Footer */
  border-top: 1px solid #374151; /* Feiner Trennstrich oben */
}

/* Auth-Bereich-Stile */
.auth-container {
  display: flex;
  gap: 15px; /* Abstand zwischen den Buttons */
}

.auth-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #3B82F6; /* Blaue Farbe */
  color: #FFFFFF;
  text-decoration: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.auth-button:hover {
  background-color: #2563EB; /* Dunklere blaue Farbe */
  transform: scale(1.05);
}

.auth-button:nth-of-type(2) {
  background-color: #10B981; /* Grüne Farbe */
}

.auth-button:nth-of-type(2):hover {
  background-color: #059669; /* Dunklere grüne Farbe */
}
</style>
